import { useEffect } from "react";
import { useRouter } from "next/router";

interface UseQueryParamTrackingProps {
  channel?: string | null;
  hasBuyerEmail: boolean;
}

/**
 * Manages query parameters in the URL for tracking and analytics.
 * - Adds channel parameter from order
 * - Adds step parameter (1 or 2) based on buyer email status
 * Uses shallow routing to avoid page reloads.
 */
export const useQueryParamTracking = ({
  channel,
  hasBuyerEmail,
}: UseQueryParamTrackingProps) => {
  const router = useRouter();

  // Add channel to URL if missing
  useEffect(() => {
    if (!router.query.channel && channel) {
      void router.replace(
        {
          pathname: router.pathname,
          query: { ...router.query, channel },
        },
        undefined,
        { shallow: true }
      );
    }
  }, [router, router.query.channel, channel]);

  // Update step based on buyerEmail state
  useEffect(() => {
    const currentStep = router.query.step as string;
    const targetStep = hasBuyerEmail ? "2" : "1";

    if (currentStep !== targetStep) {
      void router.replace(
        {
          pathname: router.pathname,
          query: { ...router.query, step: targetStep },
        },
        undefined,
        { shallow: true }
      );
    }
  }, [router, hasBuyerEmail]);
};
